import React from "react";
import BannerComponent from "../../component/Banner/Banner";

//photo banner
import IPBanner from "../Assets/Photo/AdmissionBanner.jpg";

//styles components
import {
  ParagraphBlack,
  ParagraphWhite,
  HeadingManrope,
  LineBreak,
  Container,
  HeadingTeal,
} from "../../global/global";
import {
  AdmissionSection,
  AdmissionSection2,
  AdmissionSteps,
  Contact,
  Email,
  Information,
  InformationContainer,
  Steps,
  Table,
  TealSection,
  ThingsToKnow,
  ThingsToKnowContainer,
  WhenToApply,
  Wrapper,
  WrapperText,
} from "./AdmissionStyles";

//buttons components
import { PriButton } from "../../component/Buttons/Buttons";
//faq components
import Faq from "../../component/FAQ/Faq";

const Admission = () => {
  //breadcrumbs for banner
  const breadcrumbs = [{ label: "Home", link: "/" }, { label: "Admission" }];

  //things to know steps
  const thingsToKnowSteps = [
    "Contact information for the counselor or other school representative who will complete your Common Application School Report and submit your official high school transcript.",
    "Contact information for one teacher (or two, maximum) who will complete the Teacher Evaluation form.",
    "Non-refundable $50 application fee. Students who are unable to pay the application fee can request a fee waiver.",
  ];

  //checkbox svg
  const CheckBox = () => {
    return (
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 24"
        style={{
          minWidth: "20px",
          minHeight: "20px",
          maxWidth: "20px",
          maxHeight: "20px",
        }} // Enforces consistency
      >
        <rect
          id="Rectangle_493"
          data-name="Rectangle 493"
          width="26"
          height="26"
          rx="13"
          fill="#2B7C85"
        />
        <path
          id="check"
          d="M4.46,9.26a.624.624,0,0,1-.443-.183L.184,5.242a.626.626,0,0,1,.885-.885L4.46,7.748,11.687.522a.626.626,0,0,1,.885.885L4.9,9.076A.625.625,0,0,1,4.46,9.26Zm0,0"
          transform="translate(7.139 8.718)"
          fill="#fff"
        />
      </svg>
    );
  };

  return (
    <>
      <BannerComponent
        image={IPBanner}
        title="Admission"
        breadcrumbs={breadcrumbs}
      />
      <AdmissionSection>
        <Container>
          <HeadingTeal>Detail About How To Apply</HeadingTeal>
          <ParagraphBlack>
            If you're interested in enrolling your child, we invite you to
            connect with us to learn more about our vibrant educational
            environment. Our admissions team is here to make the process smooth
            and enjoyable for you and your family. We encourage you to schedule
            a personalized school tour, where you’ll have the chance to explore
            our facilities, classrooms, and resources.
          </ParagraphBlack>
        </Container>
      </AdmissionSection>
      <TealSection>
        <Container>
          <Wrapper>
            <AdmissionSteps>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.532"
                height="41.825"
                viewBox="0 0 32.532 41.825"
              >
                <g id="application" transform="translate(-9 -2)">
                  <path
                    id="Path_364"
                    data-name="Path 364"
                    d="M37.214,42.825H13.319A3.286,3.286,0,0,1,10,39.506V6.319A3.286,3.286,0,0,1,13.319,3H37.214a3.286,3.286,0,0,1,3.319,3.319V39.506A3.328,3.328,0,0,1,37.214,42.825Z"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <path
                    id="Path_365"
                    data-name="Path 365"
                    d="M15.7,9H27.183"
                    transform="translate(-1.917 -2.018)"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <path
                    id="Path_366"
                    data-name="Path 366"
                    d="M41.4,57H34.7"
                    transform="translate(-8.305 -18.158)"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <path
                    id="Path_367"
                    data-name="Path 367"
                    d="M15.7,15h6.372"
                    transform="translate(-1.917 -4.035)"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <path
                    id="Path_368"
                    data-name="Path 368"
                    d="M15.7,24h8.562"
                    transform="translate(-1.917 -7.061)"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <g
                    id="Group_341"
                    data-name="Group 341"
                    transform="translate(13.783 24.904)"
                  >
                    <path
                      id="Path_369"
                      data-name="Path 369"
                      d="M37.67,48H15.7"
                      transform="translate(-15.7 -40.035)"
                      fill="none"
                      stroke="#f8cb3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    />
                    <path
                      id="Path_370"
                      data-name="Path 370"
                      d="M39.674,42H18.7"
                      transform="translate(-16.709 -38.018)"
                      fill="none"
                      stroke="#f8cb3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    />
                    <path
                      id="Path_371"
                      data-name="Path 371"
                      d="M37.67,36H15.7"
                      transform="translate(-15.7 -36)"
                      fill="none"
                      stroke="#f8cb3d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    />
                  </g>
                  <path
                    id="Path_372"
                    data-name="Path 372"
                    d="M39.674,30H18.7"
                    transform="translate(-2.925 -9.079)"
                    fill="none"
                    stroke="#f8cb3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                </g>
              </svg>

              <HeadingManrope>Application</HeadingManrope>
              <ParagraphWhite>
                Download and fill out this application form
              </ParagraphWhite>
            </AdmissionSteps>

            <AdmissionSteps>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="41.8"
                height="41.905"
                viewBox="0 0 41.8 41.905"
              >
                <g id="review" transform="translate(-1.097 -1)">
                  <path
                    id="Path_373"
                    data-name="Path 373"
                    d="M26.252,31.2l-2.968-2.968a.864.864,0,1,0-1.222,1.222l3.579,3.579a.943.943,0,0,0,.611.262.793.793,0,0,0,.611-.262l7.246-7.246a.864.864,0,1,0-1.222-1.222Z"
                    transform="translate(-2.629 -2.959)"
                    fill="#f8cb3c"
                  />
                  <path
                    id="Path_374"
                    data-name="Path 374"
                    d="M41.695,35.833,35.758,29.9a10.966,10.966,0,0,0,.873-3.317A11.159,11.159,0,0,0,34.1,18.373,10.608,10.608,0,0,0,30.258,15.4v-4.54A3.894,3.894,0,0,0,26.33,7.024H23.973V5.8a2.368,2.368,0,0,0-2.444-2.357H18.909A3.46,3.46,0,0,0,15.679,1a3.409,3.409,0,0,0-3.23,2.357H9.83A2.5,2.5,0,0,0,7.385,5.8V7.024H5.028A3.894,3.894,0,0,0,1.1,10.865v28.2A3.839,3.839,0,0,0,5.028,42.9h21.3a3.912,3.912,0,0,0,3.929-3.929V36.183l5.5,5.5a4.136,4.136,0,0,0,5.849,0,4.061,4.061,0,0,0,.087-5.849Zm-8.9-16.413a9.5,9.5,0,0,1-3.667,14.754h-.087a9.763,9.763,0,0,1-4.54.7,9.439,9.439,0,0,1-8.468-10.389,9.689,9.689,0,0,1,3.143-6.2l.087-.087a9.409,9.409,0,0,1,9.865-1.571,11.391,11.391,0,0,1,3.667,2.794ZM9.131,5.8a.675.675,0,0,1,.7-.611h3.4a.825.825,0,0,0,.873-.873,1.493,1.493,0,0,1,1.571-1.484,1.631,1.631,0,0,1,1.659,1.484.825.825,0,0,0,.873.873h3.4a.675.675,0,0,1,.7.611v4.19a.675.675,0,0,1-.7.611H9.83a.675.675,0,0,1-.7-.611Zm17.2,35.357H5.028a2.223,2.223,0,0,1-2.27-2.1v-28.2a2.144,2.144,0,0,1,2.183-2.1H7.3V9.992a2.368,2.368,0,0,0,2.444,2.357H21.528a2.423,2.423,0,0,0,2.444-2.357V8.77H26.33a2.144,2.144,0,0,1,2.183,2.1v3.841a7.437,7.437,0,0,0-2.008-.349,11.137,11.137,0,0,0-8.294,2.532H7.734a.873.873,0,1,0,0,1.746h8.817a12.057,12.057,0,0,0-1.484,2.532H7.822a.873.873,0,1,0,0,1.746h6.81a9.84,9.84,0,0,0-.262,1.571v.96H7.822a.873.873,0,0,0,0,1.746h6.548a13.352,13.352,0,0,0,.611,2.532H7.822a.873.873,0,1,0,0,1.746h8.032a9.118,9.118,0,0,0,2.008,2.444H7.822a.873.873,0,1,0,0,1.746H20.481a11.512,11.512,0,0,0,3.841,1.135,11.388,11.388,0,0,0,4.19-.349v2.706a2.13,2.13,0,0,1-2.183,2.008Zm14.143-.7a2.372,2.372,0,0,1-3.4,0l-5.587-5.5a10.572,10.572,0,0,0,3.4-3.4l5.5,5.5a2.3,2.3,0,0,1,.087,3.4Z"
                    transform="translate(0)"
                    fill="#f8cb3c"
                  />
                </g>
              </svg>

              <HeadingManrope>Review</HeadingManrope>
              <ParagraphWhite>
                Staff review the application and get back to you.
              </ParagraphWhite>
            </AdmissionSteps>

            <AdmissionSteps>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46.131"
                height="46.131"
                viewBox="0 0 46.131 46.131"
              >
                <defs>
                  <clipPath id="clip-path">
                    <path
                      id="path669"
                      d="M0-682.665H46.131v46.131H0Z"
                      transform="translate(0 682.665)"
                      fill="#f8cb3d"
                    />
                  </clipPath>
                </defs>
                <g id="g663" transform="translate(0 682.665)">
                  <g id="g665" transform="translate(0 -682.665)">
                    <g id="g667" clip-path="url(#clip-path)">
                      <g id="g673" transform="translate(0.901 3.244)">
                        <path
                          id="path675"
                          d="M-422.7-401.821v9.622a.9.9,0,0,1-.9.9h-28.832a.9.9,0,0,1-.9-.9v-37.842a.9.9,0,0,1,.9-.9H-423.6a.9.9,0,0,1,.9.9v22.926"
                          transform="translate(453.332 430.942)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g677" transform="translate(5.406 38.013)">
                        <path
                          id="path679"
                          d="M-161.619,0h-11.713"
                          transform="translate(173.332)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g681" transform="translate(5.406 34.276)">
                        <path
                          id="path683"
                          d="M-80.81,0h-5.856"
                          transform="translate(86.666)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g685" transform="translate(5.406 30.539)">
                        <path
                          id="path687"
                          d="M-161.619,0h-11.713"
                          transform="translate(173.332)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g689" transform="translate(5.406 26.802)">
                        <path
                          id="path691"
                          d="M-80.81,0h-5.856"
                          transform="translate(86.666)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g693" transform="translate(5.406 23.065)">
                        <path
                          id="path695"
                          d="M-161.619,0h-11.713"
                          transform="translate(173.332)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g697" transform="translate(5.406 19.328)">
                        <path
                          id="path699"
                          d="M-80.81,0h-5.856"
                          transform="translate(86.666)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g701" transform="translate(9.461 15.591)">
                        <path
                          id="path703"
                          d="M-105.668,0h-7.658"
                          transform="translate(113.326)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g705" transform="translate(5.406 11.854)">
                        <path
                          id="path707"
                          d="M-80.81,0h-5.856"
                          transform="translate(86.666)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g709" transform="translate(5.406 8.118)">
                        <path
                          id="path711"
                          d="M-161.619,0h-11.713"
                          transform="translate(173.332)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g713" transform="translate(22.325 8.117)">
                        <path
                          id="path715"
                          d="M-77.346,0l-3.737,3.737-1.868-1.868"
                          transform="translate(82.952)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g717" transform="translate(38.854 18.849)">
                        <path
                          id="path719"
                          d="M0,0,3.535,3.535"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="22.926"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g721" transform="translate(23.225 16.008)">
                        <path
                          id="path723"
                          d="M-264.608-3.868a.964.964,0,0,1,1.359,0l1.189,1.189a.964.964,0,0,1,0,1.359l-17.478,17.478-4.247,1.7,1.7-4.247Z"
                          transform="translate(283.785 4.148)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="22.926"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g725" transform="translate(22.325 15.591)">
                        <path
                          id="path727"
                          d="M-77.346,0l-3.737,3.737-1.868-1.869"
                          transform="translate(82.952)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g729" transform="translate(22.325 23.065)">
                        <path
                          id="path731"
                          d="M-77.346,0l-3.737,3.737-1.868-1.868"
                          transform="translate(82.952)"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                      <g id="g733" transform="translate(5.406 15.591)">
                        <path
                          id="path735"
                          d="M0,0H0"
                          fill="none"
                          stroke="#f9cb3d"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="2.613"
                          stroke-width="2"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              {/*todo the above svg gives problem in the svg logo of the footer adminssion page*/}

              <HeadingManrope>Admission Test</HeadingManrope>
              <ParagraphWhite>
                Older children write a test to assess their learning level.
              </ParagraphWhite>
            </AdmissionSteps>

            <AdmissionSteps>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="45.545"
                height="42.003"
                viewBox="0 0 45.545 42.003"
              >
                <path
                  id="interview"
                  d="M27.2,40.887a5.561,5.561,0,1,0-5.56-5.562A5.569,5.569,0,0,0,27.2,40.887Zm0-9.7a4.139,4.139,0,1,1-4.138,4.138A4.143,4.143,0,0,1,27.2,31.186Zm11.548,22.2H37.73v-4.35a7.59,7.59,0,0,0-7.582-7.58h-5.9a7.591,7.591,0,0,0-7.545,6.833,7.852,7.852,0,0,0-3.843-1.612,6.179,6.179,0,1,0-6.442,0C2.866,47.155.133,49.863.133,53.124V59.78A2.242,2.242,0,0,0,2.474,61.9h14.34a2.241,2.241,0,0,0,2.338-2.123V57.765h19.6a1.338,1.338,0,0,0,1.336-1.336v-1.71a1.337,1.337,0,0,0-1.336-1.336ZM28.062,48.528,27.2,50.057l-.863-1.529.527-5.651h.671Zm-3.81-5.652h1.184L24.9,48.617a.713.713,0,0,0,.089.415l1.591,2.822a.71.71,0,0,0,1.238,0l1.591-2.822a.713.713,0,0,0,.089-.415l-.536-5.741h1.184a6.165,6.165,0,0,1,6.16,6.157v4.35H32.75V49.508a.711.711,0,1,0-1.421,0v3.876H23.075V49.508a.711.711,0,1,0-1.421,0v3.876h-2.5v-.26a5.907,5.907,0,0,0-1.059-3.356v-.734a6.166,6.166,0,0,1,6.16-6.157ZM4.887,41.4a4.757,4.757,0,1,1,4.755,4.758A4.761,4.761,0,0,1,4.887,41.4ZM17.73,59.781a.841.841,0,0,1-.915.7H2.474a.844.844,0,0,1-.918-.7V53.124c0-2.813,2.689-5.1,5.994-5.1h4.188a6.3,6.3,0,0,1,5.029,2.333.734.734,0,0,0,.1.133,4.525,4.525,0,0,1,.863,2.635v6.656Zm20.934-3.437H19.151V54.806H38.663ZM43.717,19.9H33.509a1.83,1.83,0,0,0-1.828,1.828v6.616a1.83,1.83,0,0,0,1.828,1.828h.845v1.762a1.335,1.335,0,0,0,.869,1.26,1.367,1.367,0,0,0,.482.089,1.348,1.348,0,0,0,1-.452l2.372-2.66h4.635a1.83,1.83,0,0,0,1.828-1.828V21.728A1.83,1.83,0,0,0,43.717,19.9Zm.406,8.444a.411.411,0,0,1-.406.406H39.049a1.331,1.331,0,0,0-1.007.452l-2.266,2.541V30.1a1.352,1.352,0,0,0-1.351-1.349h-.916a.406.406,0,0,1-.406-.406V21.728a.406.406,0,0,1,.406-.406H43.717a.411.411,0,0,1,.406.406Zm-2.048-4.783a.71.71,0,0,1-.711.711h-5.5a.711.711,0,0,1,0-1.421h5.5A.711.711,0,0,1,42.075,23.561Zm-2.133,2.951a.71.71,0,0,1-.711.711H35.862a.711.711,0,0,1,0-1.421h3.369A.71.71,0,0,1,39.941,26.512ZM1.828,30.173H6.463l2.371,2.658a1.336,1.336,0,0,0,1,.454,1.362,1.362,0,0,0,.485-.09,1.338,1.338,0,0,0,.869-1.26V30.173h.845a1.829,1.829,0,0,0,1.825-1.828V21.728A1.829,1.829,0,0,0,12.035,19.9H1.828A1.83,1.83,0,0,0,0,21.728v6.616a1.83,1.83,0,0,0,1.828,1.829Zm-.406-8.445a.406.406,0,0,1,.406-.406H12.036a.406.406,0,0,1,.4.406v6.616a.4.4,0,0,1-.4.406h-.918A1.351,1.351,0,0,0,9.768,30.1v1.643L7.5,29.2A1.334,1.334,0,0,0,6.5,28.75H1.828a.406.406,0,0,1-.406-.406Zm2.045,1.833a.71.71,0,0,1,.711-.711h5.5a.711.711,0,1,1,0,1.421h-5.5A.71.71,0,0,1,3.467,23.561Zm6.927,2.951a.71.71,0,0,1-.711.711H6.314a.711.711,0,1,1,0-1.421H9.683A.71.71,0,0,1,10.394,26.512Z"
                  transform="translate(0 -19.9)"
                  fill="#f8cb3d"
                />
              </svg>

              <HeadingManrope>Interview</HeadingManrope>
              <ParagraphWhite>
                The final stage is an interview with school leadership.
              </ParagraphWhite>
            </AdmissionSteps>
          </Wrapper>
        </Container>
      </TealSection>
      <AdmissionSection2>
        <Container>
          <Information>
            <InformationContainer>
              <ThingsToKnow>
                <HeadingManrope>Things To Know</HeadingManrope>
                <WrapperText>
                  <ParagraphBlack>
                    Get informed on key requirements, deadlines, and steps to
                    smoothly navigate the admission process.
                    <LineBreak />
                    The requirement criteria for admission are mentioned below.
                  </ParagraphBlack>
                </WrapperText>
                <HeadingManrope style={{ fontSize: "1rem" }}>
                  You will need :
                </HeadingManrope>
                <ThingsToKnowContainer>
                  {thingsToKnowSteps.map((info, index) => (
                    <Steps key={index}>
                      <CheckBox />
                      <ParagraphBlack>{info}</ParagraphBlack>
                    </Steps>
                  ))}
                  <Steps>
                    <PriButton>Download pdf</PriButton>
                  </Steps>
                </ThingsToKnowContainer>
              </ThingsToKnow>
              <WhenToApply>
                <HeadingManrope>When To Apply?</HeadingManrope>
                <Table>
                  <tr>
                    <th></th>
                    <th>Application Deadline</th>
                    <th>Decision</th>
                  </tr>
                  <tr>
                    <td>Early Decision 1</td>
                    <td>Early Decision 1</td>
                    <td>December 15</td>
                  </tr>
                  <tr>
                    <td>Early Decision 2 </td>
                    <td>Early Decision 2 </td>
                    <td>February 15</td>
                  </tr>
                  <tr>
                    <td>Regular Decision</td>
                    <td>Regular Decision</td>
                    <td>April 1</td>
                  </tr>
                </Table>

                <HeadingManrope>
                  Where to submit necessary documents?
                </HeadingManrope>
                <ParagraphBlack>
                  Documents not submitted through the online method can be
                  mailed to:
                </ParagraphBlack>
                <Contact>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27.254"
                    height="19.163"
                    viewBox="0 0 27.254 19.163"
                  >
                    <path
                      id="Path_357"
                      data-name="Path 357"
                      d="M24.859,76H2.4A2.4,2.4,0,0,0,0,78.4V92.768a2.4,2.4,0,0,0,2.4,2.4H24.859a2.4,2.4,0,0,0,2.4-2.4V78.4A2.4,2.4,0,0,0,24.859,76Zm-.368,1.6L14.246,87.875a.932.932,0,0,1-1.237,0L2.763,77.6ZM1.6,92.474V78.689l6.87,6.893Zm1.166,1.092,6.831-6.854L11.877,89a2.527,2.527,0,0,0,3.5,0l2.283-2.29,6.831,6.853Zm22.894-1.092-6.87-6.893,6.87-6.893Z"
                      transform="translate(0 -76)"
                      fill="#2b7c85"
                    />
                  </svg>
                  <Email>
                    <a
                      href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@iwschool.edu.np"
                      target="_blank"
                    >
                      <ParagraphBlack>info@iwschool.edu.np</ParagraphBlack>
                    </a>
                    <a
                      href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@iwschool.edu.np"
                      target="_blank"
                    >
                      <ParagraphBlack>support@iwschool.edu.np</ParagraphBlack>
                    </a>
                  </Email>
                </Contact>
              </WhenToApply>
            </InformationContainer>
          </Information>
        </Container>
      </AdmissionSection2>

      {/* FAQ */}
      <Faq />
    </>
  );
};

export default Admission;
